module.exports = __webpack_public_path__ + "resource/img/plus-big.7ad758c8.svg";